/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Block to render status
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.0.0
 */
import { Fragment } from 'react';

import { EColorStatus } from '../../../../../modules/app/appConstants';
import { ImgStyled } from '../../../../common/Block/Img';
import { TableStatusBlockContainerStyled } from '../styled/ColumnsStyled';
import {
    TableTextDefaultValueStyled,
    TableTextTooltipStyled,
} from '../styled/TableBlockStyled';


interface ITableStatusBlock {
    colorState?: EColorStatus;
    defaultValue: string;
    icon?: string;
    status: string;
}

const TableStatusBlock = ({
        defaultValue,
        colorState,
        icon,
        status,
    }: ITableStatusBlock) => {

    return (
        <Fragment>
            {
                status
                ?
                <TableStatusBlockContainerStyled>
                    {
                        icon &&
                        <ImgStyled
                            className="small"
                            src={icon}
                        />
                    }
                    <TableTextTooltipStyled
                        colorState={colorState}
                    >
                        {status}
                    </TableTextTooltipStyled>
                </TableStatusBlockContainerStyled>
                :
                <TableTextDefaultValueStyled>
                    {defaultValue}
                </TableTextDefaultValueStyled>
            }
        </Fragment>
    );
};

export default TableStatusBlock;
